"use strict";

module.exports = {
  encode: require('./encode.js'),
  decode: require('./decode.js'),
  encodingLength: require('./length.js')
};